<template>
  <div id="app">
    <!-- 路由视图 - 使用keep-alive缓存所有组件 -->
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}

@media (min-width: 768px) {

  /* 全局滚动条样式：宽度 4px，主题色 #42b983 */
  * {
    scrollbar-width: thin;
    /* Firefox */
    scrollbar-color: #eee transparent;
  }

  *::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  *::-webkit-scrollbar-track {
    background-color: transparent;
  }

  *::-webkit-scrollbar-thumb {
    background-color: #eee;
    border-radius: 4px;
  }

  /* 隐藏滚动条两端的箭头按钮 */
  *::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}

.navbar {
  background: #42b983;
  color: white;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.navbar h1 {
  margin: 0;
  font-size: 24px;
}

.nav-buttons {
  display: flex;
  gap: 10px;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
}

.position-id {
  font-size: 12px;
  opacity: 0.8;
}

.logout-btn {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 5px 10px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
}

.logout-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.nav-buttons button {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.nav-buttons button:hover {
  background: rgba(255, 255, 255, 0.3);
}

.nav-buttons button.active {
  background: white;
  color: #42b983;
}

.content {
  min-height: calc(100vh - 80px);
  background: #f5f5f5;
}

/* 移动端优化 */
@media (max-width: 768px) {
  .navbar {
    padding: 10px 12px;
    gap: 8px;
  }

  .nav-buttons {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .nav-buttons button {
    padding: 6px 10px;
    font-size: 12px;
    white-space: nowrap;
  }

  .user-info {
    margin-left: 0;
    padding-left: 0;
    border-left: none;
    gap: 8px;
  }

  .position-id {
    font-size: 11px;
  }

  .logout-btn {
    padding: 4px 8px;
    font-size: 11px;
  }

  .content {
    min-height: auto;
    height: calc(100vh - 100px);
  }
}

.el-message-box {
  width: 300px !important;
}

/* 取消按钮：描边绿，字绿 */
.el-message-box__btns .el-button--default {
  border-color: #42b983 !important;
  color: #42b983 !important;
}

/* 确认按钮：面性，背景绿，字白 */
.el-message-box__btns .el-button--primary {
  color: #fff !important;
  background-color: #42b983 !important;
  border-color: #42b983 !important;
}

.el-textarea__inner:focus,
.el-input__inner:active {
  border-color: #42b983 !important;
}

@media (max-width: 768px) {
  ::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari, Opera */
  }
}

.el-form-item__error {
  z-index: 1000;
}

/* 表格多选复选框使用主题色 42b983 */
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #42b983 !important;
  border-color: #42b983 !important;
}

.el-checkbox__input.is-checked+.el-checkbox__label {
  color: #42b983 !important;
}

/* 分页组件使用主题色 42b983 */
.el-pagination .el-pager li.active {
  background-color: #42b983 !important;
  border-color: #42b983 !important;
  color: #fff !important;
}

.el-pagination .el-pager li:hover {
  color: #42b983 !important;
}

.el-pagination button:hover {
  color: #42b983 !important;
}

/* Loading 加载状态使用主题色 #42b983 */
.el-loading-mask {
  background-color: rgba(255, 255, 255, 0.8) !important;
}

.el-loading-spinner .circular {
  width: 42px;
  height: 42px;
}

.el-loading-spinner .path {
  stroke: #42b983 !important;
}

.el-loading-spinner .el-loading-text {
  color: #42b983 !important;
}

/* Select 下拉框选中项和悬停使用主题色 #42b983 */
.el-select-dropdown__item.selected {
  color: #42b983 !important;
  font-weight: 700;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: rgba(66, 185, 131, 0.1) !important;
  color: #42b983 !important;
}

.el-select-dropdown__item.selected.hover,
.el-select-dropdown__item.selected:hover {
  background-color: rgba(66, 185, 131, 0.1) !important;
  color: #42b983 !important;
}

/* Select 输入框聚焦时边框颜色 */
.el-select .el-input.is-focus .el-input__inner {
  border-color: #42b983 !important;
}

/* 其他 Element UI 组件主题色 */
/* Radio 单选按钮 */
.el-radio__input.is-checked .el-radio__inner {
  border-color: #42b983 !important;
  background: #42b983 !important;
}

.el-radio__input.is-checked+.el-radio__label {
  color: #42b983 !important;
}

/* Switch 开关 */
.el-switch.is-checked .el-switch__core {
  background-color: #42b983 !important;
  border-color: #42b983 !important;
}

/* DatePicker 日期选择器 */
.el-date-editor.el-input.is-active .el-input__inner,
.el-date-editor.el-input__inner:focus {
  border-color: #42b983 !important;
}

/* Tabs 标签页 */
.el-tabs__active-bar {
  background-color: #42b983 !important;
}

.el-tabs__item.is-active {
  color: #42b983 !important;
}

.el-tabs__item:hover {
  color: #42b983 !important;
}

/* Steps 步骤条 */
.el-steps .el-step__head.is-process {
  color: #42b983 !important;
  border-color: #42b983 !important;
}

.el-steps .el-step__head.is-finish {
  color: #42b983 !important;
  border-color: #42b983 !important;
}

.el-steps .el-step__title.is-process {
  color: #42b983 !important;
}

.el-steps .el-step__title.is-finish {
  color: #42b983 !important;
}

/* Progress 进度条 */
.el-progress-bar__inner {
  background-color: #42b983 !important;
}

/* Slider 滑块 */
.el-slider__button {
  border-color: #42b983 !important;
}

.el-slider__bar {
  background-color: #42b983 !important;
}

/* Rate 评分 */
.el-rate__icon {
  color: #42b983 !important;
}

/* Tag 标签 */
.el-tag--success {
  background-color: rgba(66, 185, 131, 0.1) !important;
  border-color: rgba(66, 185, 131, 0.2) !important;
  color: #42b983 !important;
}

/* Tree 树形控件 */
.el-tree-node__content:hover {
  background-color: rgba(66, 185, 131, 0.1) !important;
}

.el-tree-node.is-current>.el-tree-node__content {
  background-color: rgba(66, 185, 131, 0.1) !important;
  color: #42b983 !important;
}

/* Menu 菜单 */
.el-menu-item.is-active {
  color: #42b983 !important;
}

.el-submenu__title:hover {
  background-color: rgba(66, 185, 131, 0.1) !important;
  color: #42b983 !important;
}

/* Breadcrumb 面包屑 */
.el-breadcrumb__inner.is-link:hover {
  color: #42b983 !important;
}

/* Dropdown 下拉菜单 */
.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: rgba(66, 185, 131, 0.1) !important;
  color: #42b983 !important;
}

/* Notification 通知 */
.el-notification {
  border-left-color: #42b983 !important;
}

/* Message 消息提示 */
.el-message--success {
  background-color: #fff !important;
  border-color: #42b983 !important;
  color: #42b983 !important;
}

.el-message--success .el-message__icon {
  color: #42b983 !important;
}

/* Alert 警告 */
.el-alert--success {
  background-color: rgba(66, 185, 131, 0.1) !important;
  border-color: #42b983 !important;
  color: #42b983 !important;
}

.el-alert--success .el-alert__icon {
  color: #42b983 !important;
}

/* Dialog 对话框 */
.el-dialog__headerbtn:hover .el-dialog__close {
  color: #42b983 !important;
}

/* Drawer 抽屉 */
.el-drawer__header .el-drawer__close-btn:hover {
  color: #42b983 !important;
}

/* Tooltip 文字提示 */
.el-tooltip__popper[x-placement^="top"] .popper__arrow {
  border-top-color: #42b983 !important;
}

.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #42b983 !important;
}

.el-tooltip__popper[x-placement^="left"] .popper__arrow {
  border-left-color: #42b983 !important;
}

.el-tooltip__popper[x-placement^="right"] .popper__arrow {
  border-right-color: #42b983 !important;
}

/* Popover 弹出框 */
.el-popover {
  border-color: #42b983 !important;
}

/* Transfer 穿梭框 */
.el-transfer-panel__header .el-checkbox .el-checkbox__label {
  color: #42b983 !important;
}

/* Cascader 级联选择器 */
.el-cascader-node.in-active-path,
.el-cascader-node.is-active,
.el-cascader-node.is-selectable.in-checked-path {
  color: #42b983 !important;
}

/* TimePicker 时间选择器 */
.el-time-picker__input.is-active .el-input__inner,
.el-time-picker__input .el-input__inner:focus {
  border-color: #42b983 !important;
}

/* Upload 上传 */
.el-upload-list__item:hover {
  background-color: rgba(66, 185, 131, 0.1) !important;
}

.el-upload--picture-card:hover {
  border-color: #42b983 !important;
  color: #42b983 !important;
}

.back-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  color: white;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
  }
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}
</style>
<style scoped>
:deep(.el-input__inner) {
  height: 30px !important;
  line-height: 30px !important;
}

:deep(.el-textarea__inner:focus),
:deep(.el-input__inner:focus) {
  border-color: #42b983 !important;
}

:deep(.el-select) {
  width: 100% !important;
}

/* 修复图标垂直居中 */
:deep(.el-input__prefix),
:deep(.el-input__suffix) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 30px !important;
}

:deep(.el-input__prefix-inner),
:deep(.el-input__suffix-inner) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

:deep(.el-input__icon) {
  line-height: 30px !important;
  height: 30px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* 修复select下拉箭头居中 */
:deep(.el-select .el-input__suffix) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: 30px !important;
}

:deep(.el-select .el-input__suffix .el-input__suffix-inner) {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

:deep(.el-select .el-input__suffix .el-input__suffix-inner .el-input__icon) {
  line-height: 30px !important;
  height: 30px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

/* Element UI 主按钮颜色覆盖 */
:deep(.el-button--primary),
:deep(.el-button--primary:hover),
:deep(.el-button--primary:focus),
:deep(.el-button--primary:active) {
  color: #FFF;
  background-color: #42b983;
  border: 1px solid #42b983;
}

:deep(.el-button--primary.is-disabled),
:deep(.el-button--primary.is-disabled:hover),
:deep(.el-button--primary.is-disabled:focus),
:deep(.el-button--primary.is-disabled:active) {
  color: #FFF;
  background-color: #84e9bb;
  border: 1px solid #84e9bb;
}

:deep(.el-button--primary.is-plain),
:deep(.el-button--primary.is-plain:focus),
:deep(.el-button--primary.is-plain:active),
:deep(.el-button--primary.is-plain:hover) {
  color: #42b983;
  background-color: #fff;
  border: 1px solid #42b983;
}

:deep(.el-dialog--center .el-dialog__body),
:deep(.el-dialog__header),
:deep(.el-dialog__footer) {
  padding: 10px;
}

:deep(.el-dialog__headerbtn) {
  top: 10px;
  right: 10px;
}

:deep(.el-dialog__title) {
  color: #42b983;
}

::v-deep .el-form-item__label {
  line-height: 30px !important;
}

::v-deep .el-form-item__content {
  line-height: 30px !important;
}
</style>
